export default __webpack_public_path__ + "static/media/arrow_back_ios_black_24dp .65f167d7.png";